export interface EstateAdFlowSelector {
  __component: 'forms.estate-ad-flow-selector';
}

export function isEstateAdFlowSelector(obj: { __component?: string }): obj is EstateAdFlowSelector {
  return obj.__component === 'forms.estate-ad-flow-selector';
}
